import { CommomLoginAunthenticatePost, CommonAxiosPost } from "../CommonAxios/CommonAxios";
import { config } from "../CommonUrl/CommonUrls";
import Sweetalert from "../CommonPopupAndAlerts/SweetAlerts";
import axios from "axios";

const SUPPORTED_FORMATS = ['image/jpg','image/png','image/jpeg','application/pdf'];
const MAX_FILE_SIZE = 1000000;
function validateFileTypeAndSize(file, maxSize, supportedFormats, sizeMsg, imgTypeMsg) {
    let errormsg = "";

    // Validate file size
    if (file.size > maxSize) {
        errormsg += sizeMsg; // Add size error message
    }

    // Validate file type
    if (!supportedFormats.includes(file.type)) {
        errormsg += imgTypeMsg; // Add format error message
    }

    if (errormsg === "") {
        return true; // No errors
    } else {
        Sweetalert(errormsg, 'error'); // Show error messages
        return false;
    }
}
export default function ImageBucket(e, formIk, name, filename) {
    const sizeMsg = 'Please Check your file size, it should be less than 1MB\n'
    const imgTypeMsg = 'File format is invalid, Please upload only .jpg or.pdf or.png or.jpeg'
     const path = "LabourFileUploads"
    e.preventDefault();
    const file = e.target.files[0];
    const type = file.type.split("/")[1];
    const newFileName = filename + "." + type;
    const modifiedFile = new File([file], newFileName, { type: file.type });
    if (validateFileTypeAndSize(file, MAX_FILE_SIZE, SUPPORTED_FORMATS, sizeMsg, imgTypeMsg)) {
        return new Promise((resolve) => {
            const formData = new FormData();
            formData.append("file", modifiedFile);
             formData.append("path", path);

            CommonAxiosPost(config.url.FILE_UPLOAD_URL,formData)
                .then((response) => {
                    resolve(response.data);
                    formIk.setFieldValue(name, response?.data);
                })
                .catch((error) => {
                    console.log("Error at ImageBucket:", error);
                    resolve(null);
                });
        });
    } else {
        e.target.value = ''; // Reset file input if validation fails
    }

}

const SUPPORTED_FORMATS_IMG = ['image/jpg','image/png','image/jpeg'];
console.log("format",SUPPORTED_FORMATS_IMG);
const MAX_IMG_SIZE = 1000000;
export function ImageBucket_PHOTOS(e, formIk, name, filename) {
    const path = "LabourFileUploads"
    const size_msg = 'Please Check your file size, it should be less than 1MB'
    const img_type = 'File format is invalid, Please upload only .jpg or.png or.jpeg'
    e.preventDefault();
    const file = e.target.files[0];
    const type = file.type.split("/")[1];
    const newFileName = filename + "." + type;
    const modifiedFile = new File([file], newFileName, { type: file.type });
    if (validateFileTypeAndSize(file, MAX_IMG_SIZE, SUPPORTED_FORMATS_IMG, size_msg, img_type)) {
        return new Promise((resolve, reject) => {
            const formData = new FormData();
            formData.append("file", modifiedFile);
            formData.append("path", path);
            CommonAxiosPost(config.url.FILE_UPLOAD_URL , formData).then((response) => {
                resolve(response.data)
                formIk.setFieldValue(name, response?.data);
            }).catch((error) => {
                console.log("error at imagebucket", error)
                resolve(null);
            });

        });
    }
    else {
        e.target.value = '';
    }

}


export  function EmpanelImageBucket(e, formIk, name, filename) {
    const sizeMsg = 'Please Check your file size, it should be less than 1MB\n'
    const imgTypeMsg = 'File format is invalid, Please upload only .jpg or.pdf or.png or.jpeg'
     const path = "LabourFileUploads"
    e.preventDefault();
    const file = e.target.files[0];
    const type = file.type.split("/")[1];
    const newFileName = filename + "." + type;
    const modifiedFile = new File([file], newFileName, { type: file.type });
    if (validateFileTypeAndSize(file, MAX_FILE_SIZE, SUPPORTED_FORMATS, sizeMsg, imgTypeMsg)) {
        return new Promise((resolve) => {
            const formData = new FormData();
            formData.append("file", modifiedFile);
            //  formData.append("path", path);

            axios.post(config.url.FILE_UPLOAD_OPEN+path,formData)
                .then((response) => {
                    resolve(response.data);
                    formIk.setFieldValue(name, response?.data);
                })
                .catch((error) => {
                    console.log("Error at ImageBucketEmpanel:", error);
                    resolve(null);
                });
        });
    } else {
        e.target.value = ''; // Reset file input if validation fails
    }

}
export  function EmpanelImageOnlyBucket(e, formIk, name, filename) {
    const sizeMsg = 'Please Check your file size, it should be less than 1MB\n'
    const imgTypeMsg = 'File format is invalid, Please upload only .jpg or.png or.jpeg'
     const path = "OBMMS_UPLOADS"
    e.preventDefault();
    const file = e.target.files[0];
    const type = file.type.split("/")[1];
    const newFileName = filename + "." + type;
    const modifiedFile = new File([file], newFileName, { type: file.type });
    if (validateFileTypeAndSize(file, MAX_FILE_SIZE, SUPPORTED_FORMATS_IMG, sizeMsg, imgTypeMsg)) {
        return new Promise((resolve) => {
            const formData = new FormData();
            formData.append("file", modifiedFile);
            //  formData.append("path", path);

            axios.post(config.url.FILE_UPLOAD_OPEN+path,formData)
                .then((response) => {
                    resolve(response.data);
                    formIk.setFieldValue(name, response?.data);
                })
                .catch((error) => {
                    console.log("Error at ImageBucketEmpanel:", error);
                    resolve(null);
                });
        });
    } else {
        e.target.value = ''; // Reset file input if validation fails
    }

}